"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApplicationClientId = void 0;
var nanoid_1 = require("nanoid");
var createApplicationClientId = function () { return "client_".concat((0, nanoid_1.nanoid)(20)); };
exports.createApplicationClientId = createApplicationClientId;
